import {
  Badge,
  LeftRightFlexedContainer,
  QuickTable,
  QuickTableFilterTabs,
  SwitchAppButton,
} from "../../../../components";
import { ModalTopSection } from "../../../../components/DetailsModal/ModalTopSection";
import {
  DataLoadingView,
  ErrorOccuredView,
  ModalContainer,
  SectionSubheader,
} from "../../../../components";
import { CurrencyDisplay } from "../../../../components";
import {
  ITransferBatchDetailsModalViewProps,
  TRANSFERS_LIST_TABLE_NAME,
} from "./TransferBatchDetailsModal";
import { singleTransferDisplayFormatter } from "./singleTransferDisplayFormatter";
import { Routes, Route } from "react-router-dom";
import { TransferReceiptModal } from "../TransferReceiptModal";
import { getBatchTransferStatusIndicator } from "../../../../utils";
import { StatusColors } from "../../../../interfaces-and-types";
import moment from "moment";
import { appConfig } from "../../../../configs";

export const View = (props: ITransferBatchDetailsModalViewProps) => {
  const statusIndicator: {
    statusText: string;
    statusType: StatusColors;
  } | null = props.batch && getBatchTransferStatusIndicator(props.batch);

  return (
    <div className="transfer-details-container">
      <ModalContainer
        isModalOpen={props.isModalOpen}
        closeModal={props.closeModal}
        className="batch-transfer-modal-container"
        fullscreen
        modalHeader={
          !props.batch ? (
            <SectionSubheader title="BATCH TRANSFER DETAILS" />
          ) : (
            <ModalTopSection
              header="BATCH TRANSFER DETAILS"
              subHeader={
                <div className="name-sub-header flex-container align-items--end justify-content--start">
                  <h5>TOTAL: &nbsp;</h5>
                  <CurrencyDisplay
                    currencyOrSymbol={props.batch.source_currency}
                    amount={props.batch.total_amount}
                  />
                  &nbsp; &nbsp; <h5>TOTAL FEES: &nbsp;</h5>
                  <CurrencyDisplay
                    currencyOrSymbol={props.batch.source_currency}
                    amount={props.batch.total_fee}
                  />
                </div>
              }
              copyText="Batch Ref"
              copyContent={props.batch.batch_reference}
              closeModal={props.closeModal}
            />
          )
        }
      >
        {!props.batch ? null : (
          <>
            <div className="flex-container row">
              <div className="flex-box">
                <div className="pl-5 pr-5">
                  {!props.batch.title ? null : (
                    <LeftRightFlexedContainer
                      key_id="Batch Title"
                      value={props.batch.title}
                    />
                  )}
                  <LeftRightFlexedContainer
                    key_id="Total Count"
                    value={props.batch.total_count}
                  />
                  <LeftRightFlexedContainer
                    key_id="Total Failed"
                    value={props.batch.failed_count}
                  />
                  <LeftRightFlexedContainer
                    key_id="Total Successful"
                    value={props.batch.successful_count}
                  />
                  <LeftRightFlexedContainer
                    key_id="Status"
                    value={
                      <Badge
                        text={statusIndicator!.statusText}
                        statusColor={statusIndicator!.statusType}
                      />
                    }
                  />
                  {!props.batch.is_approval_required ? null : (
                    <>
                      <LeftRightFlexedContainer
                        key_id="Authorization Count Required"
                        value={props.batch.approval_count_required}
                      />
                      <LeftRightFlexedContainer
                        key_id="Current Authorization Count"
                        value={props.batch.approval_count}
                      />
                    </>
                  )}
                  <LeftRightFlexedContainer
                    key_id="Created At"
                    value={moment(props.batch.created_at).format(
                      appConfig.dateTimeFormat
                    )}
                  />
                  {props.batch.is_approval_required &&
                  !props.batch.is_approved ? (
                    <LeftRightFlexedContainer
                      key_id="Authorization Expires At"
                      value={
                        <Badge
                          text={
                            props.batch.approval_expires_at
                              ? moment(props.batch.approval_expires_at).format(
                                  appConfig.dateTimeFormat
                                )
                              : "No expiry"
                          }
                          statusColor={"warning"}
                          hideIndicator
                          indicatorSize="sm"
                        />
                      }
                    />
                  ) : null}
                  {props.isSuccessTeamMembers &&
                  props.teamMembersList.length > 0 &&
                  props.batch.is_approval_required &&
                  props.batch.is_approved ? (
                    <LeftRightFlexedContainer
                      key_id="Authorized At"
                      value={moment(props.batch.approved_at).format(
                        appConfig.dateTimeFormat
                      )}
                    />
                  ) : null}
                  {props.isSuccessTeamMembers &&
                  props.teamMembersList.length > 0 &&
                  props.batch.is_approval_required ? (
                    <LeftRightFlexedContainer
                      key_id="Authorized By"
                      value={props.batch?.approver_staff_list.map(
                        (approverStaffId) => (
                          <Badge
                            text={
                              props.teamMembersList.find(
                                (m) => m.id === approverStaffId
                              )?.full_name ?? "Unknown Authorizer"
                            }
                            statusColor={"teal"}
                            className="mr-3"
                          />
                        )
                      )}
                    />
                  ) : null}
                </div>

                <div className="bg-gray-2 pl-5 pr-5 pt-5 b-r-5">
                  <LeftRightFlexedContainer
                    key_id="Total Amount"
                    value={
                      <CurrencyDisplay
                        amount={props.batch.total_amount}
                        currencyOrSymbol={props.batch.source_currency}
                        amountFontSize={18}
                        symbolFontSize={10}
                      />
                    }
                  />
                  <LeftRightFlexedContainer
                    key_id="Successful Amount"
                    value={
                      <CurrencyDisplay
                        amount={props.batch.total_successful_amount}
                        currencyOrSymbol={props.batch.source_currency}
                        amountFontSize={18}
                        symbolFontSize={10}
                      />
                    }
                  />
                  <LeftRightFlexedContainer
                    key_id="Total Fees"
                    value={
                      <CurrencyDisplay
                        amount={props.batch.total_fee}
                        currencyOrSymbol={props.batch.source_currency}
                        amountFontSize={18}
                        symbolFontSize={10}
                      />
                    }
                  />
                </div>
              </div>

              <div className="">
                {props.batch.failed_count === 0 ? null : (
                  <SwitchAppButton
                    size="sm"
                    kind="primary"
                    className="mb-5"
                    onClick={props.retryFailedTransfersInBatch}
                  >
                    RETRY ALL FAILED TRANSFERS
                  </SwitchAppButton>
                )}

                {props.batch.is_approval_required &&
                !props.batch.is_approved ? (
                  <SwitchAppButton
                    size="sm"
                    kind="success"
                    className="ml-5 mb-5"
                    onClick={props.authorizeTransfersInBatch}
                    isLoading={props.isLoadingAuthorizeTransfersInBatch}
                    // disabled={moment(props.batch.approval_expires_at).isBefore(
                    //   moment()
                    // )}
                  >
                    APPROVE ALL TRANSFERS
                  </SwitchAppButton>
                ) : null}
              </div>
            </div>
          </>
        )}

        {!props.transfersInBatch ? (
          <>
            {props.isLoading ? (
              <DataLoadingView message={"Loading transfer details"} />
            ) : (
              <ErrorOccuredView
                message={
                  "An error occured while loading the transfer details. Please retry..."
                }
              />
            )}
          </>
        ) : (
          <>
            <QuickTable
              id={TRANSFERS_LIST_TABLE_NAME}
              prefixFiltersWithId
              data={props.transfersInBatch}
              headers={props.headers}
              isLoading={props.isLoading}
              isError={props.isError}
              itemCount={props.totalCount}
              renderDetail={(item) => item.description}
              toolbarTabs={
                <QuickTableFilterTabs
                  queryStringTabNavLinks={props.queryStringTabs}
                  filterPrefix={TRANSFERS_LIST_TABLE_NAME}
                />
              }
              displayFormatter={singleTransferDisplayFormatter}
              onExport={props.onExport}
              openDetailsModal={props.openSingleTransferDetailsReceiptModal}
              detailsModalKeySelector={(trsf) => trsf.id}
              rowTitleSelector={(trsf) => trsf.description ?? null}
              disableClickOnColumns={[
                "account_name",
                "account_number",
                "session_id",
              ]}
            />
          </>
        )}
      </ModalContainer>

      <Routes>
        <Route path=":id/receipt" element={<TransferReceiptModal />} />
      </Routes>
    </div>
  );
};
